import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "./ui/input";

/** Campo de contraseña con opción de verla mientras se escribe. */
export const PasswordInput = ({ id, testid, value, onChange, className = "", ...rest }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input id={id} data-testid={testid} type={show ? "text" : "password"} value={value}
        onChange={onChange} className={`pr-14 ${className}`} {...rest} />
      <button type="button" data-testid={`${testid}-toggle`} tabIndex={-1}
        onClick={() => setShow((s) => !s)}
        aria-label={show ? "Ocultar la contraseña" : "Ver la contraseña"}
        title={show ? "Ocultar la contraseña" : "Ver la contraseña"}
        className="absolute right-3 top-1/2 -translate-y-1/2 rounded-lg p-2 text-ink-700 transition-colors hover:bg-cream">
        {show ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
      </button>
    </div>
  );
};
